import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
  name: 'locationKind',
})
export class LocationKindPipe implements PipeTransform {
  transform(stock?: Stock, kind?: LocationKind): string | undefined {
    if (!stock) {
      return ''
    }
    if (!stock.place?.length || kind == 'TICKET_PALLET' || kind == 'TOTE') {
      return ''
    }
    const places = stock.place?.filter((p) => p.kind == kind)
    return places.length ? places[0].label : ''
  }
}

interface Stock {
  _id: string
  place?: StockPlace[]
}

export interface StockPlace {
  _id: string
  label: string
  kind?: LocationKind
}

type LocationKind =
  | 'AISLE'
  | 'AREA'
  | 'COMPARTMENT'
  | 'POSITION'
  | 'RACK'
  | 'SHELF'
  | 'TOTE'
  | 'TICKET_PALLET'
